import { palette } from '@livable/saas-react-components';
const MuiLoadingButton = {
  styleOverrides: {
    root: {
      maxHeight: '48px',
      transition: "all ".concat(palette.transitions.short),
      '& .MuiSvgIcon-root path': {
        fill: palette.shades[100]
      },
      '&:disabled': {
        background: palette.shades[400],
        color: palette.shades[100]
      },
      '& .MuiButton-startIcon': {
        marginLeft: '0'
      }
    },
    loadingIndicator: {
      position: 'static',
      marginRight: '0',
      marginLeft: '0',
      '& path': {
        fill: palette.shades[100]
      }
    },
    loading: {
      '& .MuiButton-startIcon': {
        display: 'none'
      }
    }
  }
};
export default MuiLoadingButton;